module.exports = __webpack_public_path__ + "img/NewsCenterDetails4_pic3.0cf059e6.png";